/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TabValue } from "../config";
import { TAB_CONFIG } from "../config";

interface ErrorStateProps {
  tab: TabValue;
  error: string;
  onRetry: () => void;
}

export const ErrorState = defineComponent<ErrorStateProps>({
  name: "ErrorState",
  props: ["tab", "error", "onRetry"] as any,
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const config = TAB_CONFIG[props.tab];
      const label = config.type === "request" ? "requests" : "reservations";

      return (
        <div class="flex items-center justify-center h-96">
          <div class="text-center bg-base-100 rounded-2xl p-10 shadow-lg border border-base-300/50 max-w-md">
            <div class="w-16 h-16 rounded-full bg-error/10 flex items-center justify-center mx-auto mb-6">
              <span class="material-symbols-outlined text-error text-3xl">
                error
              </span>
            </div>
            <h3 class="font-semibold text-accent text-lg mb-2">
              Unable to load {label}
            </h3>
            <p class="text-sm text-base-content/60 mb-6">{props.error}</p>
            <button
              type="button"
              onClick={props.onRetry}
              class="btn btn-primary btn-sm gap-2"
            >
              <span class="material-symbols-outlined text-lg">refresh</span>
              {t("reservations.general.try_again")}
            </button>
          </div>
        </div>
      );
    };
  },
});
